import { getDiastereotopicAtomIDs } from 'openchemlib-utils';
import { predictCOSY } from './predictCOSY';
import { predictCarbon } from './predictCarbon';
import { predictHMBC } from './predictHMBC';
import { predictHSQC } from './predictHSQC';
import { predictProton } from './predictProton';
import { getPredictions } from './utils/getPredictions';
/**
 * Generate the correlation bidimensional nmr peaks based on the number of bonds between a pair of atoms
 * @returns {Promise<object>} - object with molfile, diaIDs, 1D and 2D signals, joined signals, ranges and zones.
 */
export async function predictAll(molecule, options = {}) {
    let { logger, predictor = { H: predictProton, C: predictCarbon }, predictions, joinDistance = { H: 0.05, C: 0.5 }, predictOptions = {}, } = options;
    const diaIDs = getDiastereotopicAtomIDs(molecule);
    const xPrediction = await getPredictions('H', molecule, predictOptions, predictor, predictions);
    const yPrediction = await getPredictions('C', molecule, predictOptions, predictor, predictions);
    if (!xPrediction || !yPrediction) {
        throw new Error('predictions are not availaible');
    }
    const spectra = {};
    if (check1DPrediction(xPrediction)) {
        spectra.proton = xPrediction;
    }
    if (check1DPrediction(yPrediction)) {
        spectra.carbon = yPrediction;
    }
    const { molfile } = xPrediction;
    predictions = {
        H: xPrediction,
        C: yPrediction,
    };
    if (spectra.proton) {
        spectra.cosy = await predictCOSY(molecule, {
            predictions,
            joinDistance,
        });
    }
    else if (logger) {
        logger.warn('Proton prediction is missing so COSY could not be generated.');
    }
    if (spectra.carbon && spectra.proton) {
        spectra.hsqc = await predictHSQC(molecule, {
            predictions,
            joinDistance,
        });
        spectra.hmbc = await predictHMBC(molecule, {
            predictions,
            joinDistance,
        });
    }
    else if (logger) {
        logger.warn('Carbon and / or proton prediction is missing so HSQC and HMBC could not be generated.');
    }
    for (const key in spectra) {
        delete spectra[key].molfile;
        delete spectra[key].diaIDs;
    }
    return {
        molfile,
        diaIDs,
        spectra,
    };
}
function check1DPrediction(prediction) {
    if (!prediction)
        return false;
    if (prediction.ranges.length === 0)
        return false;
    const { signals, diaIDs } = prediction;
    for (const signal of signals) {
        const isCorrect = signal.diaIDs?.every((diaID) => diaIDs.includes(diaID));
        if (!isCorrect)
            return false;
    }
    return true;
}
//# sourceMappingURL=predictAll.js.map